// StepTargetLanguages.tsx
import React from "react";
import {
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionPanel,
  AccordionIcon,
  Box,
  Button,
  Flex,
} from "@chakra-ui/react";
import LanguageConfiguration from "./LanguageConfiguration.tsx";
import LanguageInput from "./LanguageInput.tsx";
import {ILanguageConfiguration} from "../../models/interfaces/languageConfiguration.interface.ts";
import LanguageDefaultConfiguration from "../LanguageDefaultConfigurationIcon.tsx";

interface StepTargetLanguagesProps {
  availableLanguages: string[];
  selectedSourceLanguage: string;
  selectedTargets: Record<string, ILanguageConfiguration>;
  onAddLanguage: (lang: string) => void;
  onRemoveLanguage: (lang: string) => void;
  setTargetConfig: (lang: string, config: Partial<ILanguageConfiguration>) => void;
}

const StepTargetLanguages: React.FC<StepTargetLanguagesProps> = (
  {
    availableLanguages,
    selectedSourceLanguage,
    selectedTargets,
    onAddLanguage,
    onRemoveLanguage,
    setTargetConfig,
  }) => {
  const [isInputOpen, setIsInputOpen] = React.useState(false);
  const [inputValue, setInputValue] = React.useState("");

  const remainingLanguages = availableLanguages.filter(l => !Object.keys(selectedTargets).includes(l) && l !== selectedSourceLanguage);

  return (
    <div className="flex flex-col gap-2 w-full min-h-[500px] max-h-[500px]">
      {/* Language Picker */}
      <LanguageInput
        isOpen={isInputOpen}
        setIsOpen={setIsInputOpen}
        languages={remainingLanguages}
        selectedLanguage={inputValue}
        onSelectLanguage={(lang) => {
          onAddLanguage(lang);
          setInputValue("");
        }}
        onChange={(value) => setInputValue(value)}
        placeholder="Select target language"
      />

      {/* Accordion per Target */}
      <Accordion allowToggle className="overflow-y-auto">
        {Object.keys(selectedTargets).map((lang: string) => (
          <Box key={lang} my={4}>
            <AccordionItem key={lang} border="none" borderBottom="1px solid gray">
              <h2>
                <AccordionButton color="white">
                  <Box flex="1" textAlign="left">{lang}</Box>
                  <AccordionIcon/>
                </AccordionButton>
              </h2>
              <AccordionPanel pb={4}>
                <Flex className="relative" direction="column" gap={2}>
                  <LanguageDefaultConfiguration
                    lang={lang}
                    currentConfig={selectedTargets[lang]}
                    updateConfig={(config) => setTargetConfig(lang, config)}
                  />
                  <LanguageConfiguration
                    config={selectedTargets[lang]}
                    setConfig={(update) => setTargetConfig(lang, update)}
                  />
                  <Button size="sm" colorScheme="red" onClick={() => onRemoveLanguage(lang)}>
                    Remove
                  </Button>
                </Flex>
              </AccordionPanel>
            </AccordionItem>
          </Box>
        ))}
      </Accordion>
    </div>
  );
};

export default StepTargetLanguages;